import useMediaQuery from 'beautiful-react-hooks/useMediaQuery';
import { useMemo } from 'react';

export interface UseWindowSizeOptions {
  minSmallPhoneWidth?: number;
  minPhoneWidth?: number;
  minTabletWidth?: number;
  minDesktopWidth?: number;
  minDesktopLargeWidth?: number;
  minDesktopExtraLargeWidth?: number;
}

const defaultOptions: UseWindowSizeOptions = {
  minSmallPhoneWidth: 375,
  minPhoneWidth: 440,
  minTabletWidth: 768,
  minDesktopWidth: 960,
  minDesktopLargeWidth: 1200,
  minDesktopExtraLargeWidth: 1440,
};

export const useWindowSize = (options?: UseWindowSizeOptions) => {
  const opts = useMemo(() => ({ ...defaultOptions, ...options }), [options]);

  const isExtraSmallMobile = useMediaQuery(`(max-width: ${opts.minSmallPhoneWidth - 1}px)`);
  const isSmallMobile = useMediaQuery(`(max-width: ${opts.minPhoneWidth - 1}px)`);
  const isMobile = useMediaQuery(`(max-width: ${opts.minTabletWidth - 1}px)`);
  const isTablet = useMediaQuery(
    `(min-width: ${opts.minTabletWidth}px) and (max-width: ${opts.minDesktopWidth - 1}px)`,
  );
  const isDesktop = useMediaQuery(`(min-width: ${opts.minDesktopWidth}px)`);
  const isDesktopSmall = useMediaQuery(
    `(min-width: ${opts.minDesktopWidth}px) and (max-width: ${opts.minDesktopLargeWidth - 1}px)`,
  );
  const isDesktopLarge = useMediaQuery(
    `(min-width: ${opts.minDesktopLargeWidth}px) and (max-width: ${opts.minDesktopExtraLargeWidth - 1}px)`,
  );
  const isDesktopExtraLarge = useMediaQuery(`(min-width: ${opts.minDesktopExtraLargeWidth}px)`);

  const isPortrait = useMediaQuery('(orientation: portrait)');
  const isLandscape = useMediaQuery('(orientation: landscape)');
  const isHoverDevice = useMediaQuery('(hover: hover)');

  return useMemo(
    () => ({
      isExtraSmallMobile,
      isSmallMobile,
      isMobile,
      isTablet,
      isDesktop,
      isDesktopSmall,
      isDesktopLarge,
      isDesktopExtraLarge,
      isPortrait,
      isLandscape,
      isHoverDevice,
    }),
    [
      isDesktop,
      isDesktopExtraLarge,
      isDesktopLarge,
      isDesktopSmall,
      isExtraSmallMobile,
      isHoverDevice,
      isLandscape,
      isMobile,
      isPortrait,
      isSmallMobile,
      isTablet,
    ],
  );
};
